import { createQueryClient, type SagotClient } from "@sagot/api-client";
import { I18nextProvider, type I18nInstance } from "@sagot/i18n";
import { LinkProvider, ThemeProvider, Toaster, TooltipProvider } from "@sagot/ui";
import { RouterLink } from "@sagot/ui/router";
import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { RouterProvider, createBrowserRouter, type RouteObject } from "react-router";
import { SessionProvider } from "../session/session-provider";
import { consoleClient } from "./api";
import { consoleRouteTree } from "./routes";

export interface AppProps {
  i18n: I18nInstance;
  routes?: RouteObject[];
  client?: SagotClient;
}

export function App({ i18n, routes = consoleRouteTree, client = consoleClient }: AppProps) {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => createBrowserRouter(routes));
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <SessionProvider client={client}>
          <ThemeProvider>
            <TooltipProvider>
              <LinkProvider component={RouterLink}>
                <RouterProvider router={router} />
                <Toaster />
              </LinkProvider>
            </TooltipProvider>
          </ThemeProvider>
        </SessionProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
